import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { resetCoupaFileUpload, setCoupaFileUploadStart, setCoupaFile } from "../redux/reducers/coupaFileUploadSlice";


export const useCoupaFileUpload = () => {
  const { t } = useTranslation(); 
  const dispatch = useDispatch()
  const fileImportRef = useRef(null);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [snackBar, setSnackBar] = useState({
    open: false,
    severity: "",
    autoHideDuration: 0,
    message: "",
  });

  const { coupaFile, successMessage:uploadSuccessMsg, errorMessage: uploadErrorMsg  } = useSelector(
      (state) => state.drmCoupaFile
    );

  const handleImportClick = () => {
    fileImportRef.current.click();
  };

  const handleFileImport = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const allowedTypes = [".csv", ".xlsx", ".xls"];
    const fileExtension = file.name
      .toLowerCase()
      .slice(file.name.lastIndexOf("."));

    if (!allowedTypes.includes(fileExtension)) {
      setSnackBar({
        open: true,
        severity: "error",
        autoHideDuration: 6000,
        message: t('coupa_file_upload_error'),
      });
      return;
    }
    dispatch(
      setCoupaFile({
        coupaFileName: file.name,
        coupaFileContent: file,
      })
    );
     event.target.value = null;
  };

  useEffect(()=>{
    if(uploadErrorMsg || uploadSuccessMsg){
       setSnackBar({
        open: true,
        severity: uploadSuccessMsg ? 'success':'error',
        autoHideDuration: 6000,
        message: uploadSuccessMsg ? uploadSuccessMsg:uploadErrorMsg,
      });
    }
  },[ uploadSuccessMsg, uploadErrorMsg])

  const handleOpenConformationMsg = () => {
    setIsConfirmationOpen(true);
  };

  const handleCloseConformationMsg = () => {
    setIsConfirmationOpen(false);
    dispatch(resetCoupaFileUpload());
  };

  const handleConfirm = () => {
    const formData = new FormData();
    formData.append("file", coupaFile.coupaFileContent);
    const controller = new AbortController();
    dispatch(setCoupaFileUploadStart({ formData, controller }));
    setIsConfirmationOpen(false);
    return () => {
      controller.abort();
    };
  };
  const handleSnackClose = () => {
    setSnackBar({
      open: false,
      severity: "",
      autoHideDuration: 0,
      message: "",
    });
  };

  return {
    fileImportRef,
    isConfirmationOpen,
    snackBar,
    handleSnackClose,
    handleImportClick,
    handleFileImport,
    handleOpenConformationMsg,
    handleCloseConformationMsg,
    handleConfirm,
  };
};
